<template>
  <div class=priprotocol>
    <mt-header title="用户注册与使用协议">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
    </mt-header>
    <div class="wrap">
	<div>
		本网站由北京联合信任技术服务有限公司（以下简称“联合信任”）负责运营。本用户注册与使用协议（以下简称“本协议”）具有合同效力，协议双方为联合信任与本网站的注册用户（以下简称“用户”），适用于注册用户在本网站的全部活动。
	</div>
	<div class="bold">
		在成为本网站的注册用户前请务必仔细阅读本协议的全部内容，若不同意或不理解本协议的任何内容，请不要进行后续操作。
	</div>
	<div>
		完成本网站的全部注册操作后即成为本网站的注册用户，这表明用户对本协议的全部内容已充分阅读、理解和同意遵守（用户不应以未阅读本协议的内容等理由，主张本协议无效，或要求撤销）。同时，用户承诺遵守中国法律、法规、规章及其他政府规范性文件的规定，如有违反将独立承担所有相应的法律责任。
	</div>
	<div class="h1">
		一、声明与告知
	</div>
	<div>
		1.本协议的内容包括以下全部条款以及本网站已经发布的及将来可能发布的与用户有关的各项规则，该等规则均为本协议不可分割的一部分，与本协议具有同等法律效力。
	</div>
	<div>
		2.本网站有权根据经营需要修改本协议的内容。如本协议条款或本网站各项规则有任何变更，本网站将在网站上刊载公告。经修订的相关条款和规则一经公告，即于公告规定的特定生效日期自动生效。请用户适时关注本网站关于相关条款和规则的公告，如不同意该等变更，请用户在该等变更的公告刊载之日起72 小时内以用户在本网站注册时提供的个人邮箱向本网站的服务邮箱_【service@tsa.cn】 _发送邮件明确表明希望终止本协议（“注销申请”），本网站确认收到用户的邮件后将与用户协商本协议的终止以及终止后双方权利义务的履行。如用户在本条款所述时限内未发送注册终止申请，则本条款所述时限届满之时，视为用户已经同意接受该等变更，经修订的相关条款和规则一经公告，即于公告规定的特定生效日期自动生效并对用户产生法律约束力。
	</div>
	<div>
		3.本网站有权中止、终止或者限制提供相关服务的部分功能，或提供新的功能，在任何功能减少、增加或者变化时，只要用户仍然使用本服务，表示用户仍然同意本协议或者变更后的协议。
	</div>
	<div>
		4.本协议不涉及本网站注册用户之间因使用本网站服务而产生的法律关系及法律纠纷。
	</div>
	<div>
		5.本网站保留中止、终止或限制用户使用本网站服务的权利，但该等终止、中止或限制行为并不必然导致用户之前合法使用本网站服务产生的数据无效或被删除。
	</div>
	<div>
		6.用户应妥善保管自己的账户密码等账户信息，用户不得以账户密码等账户信息被盗用或其他理由否认在本网站的任何操作。
	</div>
	<div>
		7.联合信任对本网站内所有非公有领域或非他方专有的信息内容享有知识产权（包括但不限于商标权、专利权、著作权），信息内容包括但不限于文字、图片、软件、音频、视频、数据、源代码、设计，非经联合信任书面授权同意，禁止复制、打印和传播属于联合信任的信息内容用于其他用途。
	</div>
	<div>
		8.联合信任对本网站所有的产品、技术及程序享有知识产权，非经联合信任书面授权许可，禁止使用（包括但不限于以非法的方式打印、复制、传播、展示、下载等）。
	</div>
	<div class="h1">
		二、名词解释
	</div>
	<div>
		1.<span class="bold">账户：</span>是本网站为用户提供的电子信息空间，且用户在本网站拥有唯一编号。用户可自行为该账户设置密码，并用以查询或使用本网站提供的服务。用户需使用本人电子邮箱或手机号码，或者本公司允许的其它方式登录该账户。
	</div>
	<div class="red">
		2.<span class="red bold">本网站：</span>除本协议另有规定外，指www.tsa.cn及（或）移动客户端应用程序“权利卫士”及（或）为完成相关服务而设立的www.tsa.cn的子网站或独立运营的网站，包括www.tsa.cn、www.1sign.cn、权利卫士APP。
	</div>
	<div>
		3.<span class="bold">时间戳：</span>是由联合信任时间戳服务中心（TSA：Time Stamp Authority）颁发的具有法律效力的电子凭证, 用于证明电子数据申请认证的时间和内容完整性。
	</div>
	<div>
		4.<span class="bold">时间戳的认证：</span>用户申请可信时间戳认证，只需将电子数据的哈希（Hash）值上传。本网站将接收到的电子数据的哈希（Hash）值后与权威时间源绑定（由国家授时中心负责授时和守时，即电子数据申请时间戳认证后申请时间将无法修改），在此基础上通过联合信任的私钥进行签名，生成不可伪造的时间戳文件（后缀名为.tsa的文件）。
	</div>
	<div>
		5.<span class="bold">时间戳的验证：</span>用户对电子数据进行时间戳验证时将电子数据与对应的时间戳文件（包含电子数据的哈希值和权威时间）进行技术比对，可以有效确认电子数据的产生时间及自形成时起内容是否保持完整、未被更改。
	</div>
	<div>
		6.<span class="bold">电子签章：</span>是电子签名的一种表现形式的实现工具，利用图像处理技术将电子签名操作转化为与纸质文件盖章操作相同的可视效果。
	</div>
	<div>
		7.<span class="bold">数字证书：</span>是一个经证书授权中心数字签名的包含公开密钥拥有者信息（即名称以及证书授权中心的数字签名）以及公开密钥的文件。数字证书只在特定的时间段内有效。同时集成第三方数字证书和可信时间戳可以实现可靠电子签名，保障电子信息的真实性和完整性以及签名人的不可否认性。
	</div>
	<div>
		8.<span class="bold">电子证据固化：</span>是指平台所产生的电子数据即时加盖由联合信任时间戳服务中心（TSA：Time Stamp Authority）颁发的时间戳，以确保该数据满足《电子签名法》第二章第五条数据电文原件形式之规定。
	</div>
	<div>
		9.<span class="bold">GPS定位系统：</span>是指利用卫星，在全球范围内实时进行定位、导航的系统，简称GPS(Global Positioning System)。
	</div>
	<div>
		10.<span class="bold">GPS 定位误差：</span>通过地面接收设备接收卫星传送来的信息，计算同一时刻地面接收设备到多颗卫星之间的伪距离，采用空间距离后方交会方法，来确定地面点的三维坐标。对于GPS卫星、卫星信号传播过程和地面接收设备都会对GPS 定位产生误差。
	</div>
	<div class="h1">
		三、服务内容和服务费用
	</div>
	<div>
		1.本网站提供的服务包括:
	</div>
	<div class="h3">
		1) 可信时间戳服务：联合信任为各行业提供符合RFC3161标准的可信时间戳服务，对外开放API接口，各类应用系统只要按照标准即可接入本网站并获取服务。
	</div>
	<div class="h3">
		2) 可靠电子签名（电子合同）服务：实现传统纸质合同签署的电子化，主要包括实名认证，合同签署，合同管理，签署提醒等功能，可根据用户需求实现多种电子合同签约的部署方式。
	</div>
	<div class="h3">
		3) 知识产权保护服务：对文学、艺术和自然科学、社会科学、工程技术等各类作品进行可信时间戳认证，用于证明申请认证的知识产权（电子数据、文件）是谁（who）在什么时间（when）拥有一个什么样的作品（what）。
	</div>
	<div class="h3">
		4) 电子证据固化保全服务：及时固定证据、防止证据灭失，客观真实的还原事实真相。
	</div>
	<div class="h3">
		5) 接受用户的委托为用户提供的其他服务。
	</div>
	<div>
		2.用户使用本网站提供的服务，均需另行完成开通操作，并遵守相关服务规则。
	</div>
	<div>
		3.当用户使用本网站提供的服务，本网站有权向用户收取相应的服务费用。各项服务具体费用标准请直接联系本网站公布的客服电话或参看本网站上公布的业务定价及有关规则。用户按照本网站的操作流程支付服务费用后方可使用本网站提供的服务，用户购买本网站的服务后如未使用或未全部使用本网站有权不退还相关费用。
	</div>
	<div>
		4.联合信任拥有单方面制定与调整各项服务费用的权利，费用调整规则以本网站公布为准。
	</div>
	<div class="h1">
		四、注册与注销
	</div>
	<div>
		1.注册用户包括企业用户和个人用户。企业用户是依据中华人民共和国法律在境内（香港、台湾、澳门除外）设立的，能够独立承担民事责任的法人和其他组织。个人用户是指中华人民共和国境内（香港、台湾、澳门除外）的公民，并且符合中华人民共和国法律规定的具有完全民事行为能力，能够独立承担民事责任的自然人<span class="bold">（例外：本网站的部分功能可以向18岁以下的未成年人提供服务，但需要在相关页面单独提出申请并完成注册）。</span>
	</div>
	<div>
		2.个人及企业在本网站完成注册即可成为注册用户，成为注册用户后须进行实名认证，实名认证通过后方有权利开通本网站的服务。
	</div>
	<div>
		3.在注册、实名认证、使用本网站服务的所有期间，用户应提供真实资料和信息，并保证自注册之时起至使用本网站服务的所有期间，用户所提交的所有资料和信息真实、准确、完整，且是最新的。根据实名认证方式的不同，个人所需提供的实名认证资料将有所差异，具体所需资料请以本网站要求为准。企业需要提供的实名认证资料包括但不限于营业执照、组织机构代码证、税务登记证，企业法定代表人姓名及其身份证信息，并且企业法定代表人需要手持身份证拍照进行认证，本网站认为有必要时还需要进行企业银行基本账户认证。用户同意并授权联合信任审核、核实用户资料信息并有权保存所有用户提交的认证信息，核实后的用户认证信息将用于核发其专属的电子签名文件。
	</div>
	<div>
		4.因国家法律法规、部门规章或监管机构的要求，本网站需要用户补充提供任何相关资料时，如用户不能及时配合提供，本网站有权中止或终止向该用户提供部分或全部服务，就此产生的损失联合信任不承担任何责任。
	</div>
	<div>
		5.在用户决定不再使用该账户时，用户应将该账户内的可用数据先行导出或删除后，再并按本网站规定流程向本网站申请注销该账户，否则因账户注销导致的数据丢失用户自行承担。异常账户（处于中止状态的账户）需按提示操作并恢复正常后方可进行注销。账户注销后，本协议自动终止，本网站有权选择不可恢复的清除账户内全部数据或保留账户内的相关信息，任何基于已清除的账户内数据而产生的未了结的权利义务与联合信任无关。
	</div>
	<div>
		6.用户申请注销账户一旦成功，将不再予以恢复，如需再次使用和开通服务应重新进行注册。
	</div>
	<div class="bold">
		7. <span class="border">用户理解并同意</span>，如用户连续24个月未登录过其在本网站的注册账户，且用户在本网站无任何剩余资产或在本网站无任何数据留存或无任何服务的使用痕迹，本公司有权无需通知即注销该用户的注册账户。
	</div>
	<div class="h1">
		五、使用与使用限制
	</div>
	<div>
		1.如用户向本网站提供的各项信息和资料发生变更，应当及时向本网站更新相应的信息和资料，如因用户未及时更新信息和资料导致本网站无法向用户提供服务或发生错误，由此导致的全部法律责任和后果将由用户独立承担。
	</div>
	<div>
		2.基于计算机端、手机端以及其他电子设备的用户使用习惯，本网站有权在用户使用具体产品时设置相同或不同的账户登录模式及采取不同的措施识别用户的身份，并将同一身份用户纳入同一账户进行管理。
	</div>
	<div>
		3.使用本网站服务，用户应遵从本协议或网站说明页面中的操作提示、规则，否则造成无法达成使用服务之目的的由用户自行承担责任。
	</div>
	<div>
		4.用户在本网站登录状态结束时，应以正确步骤退出账户。因用户未遵守本条规定而发生的任何损失及不利后果由用户自行承担责任。
	</div>
	<div>
		5.如用户发现他人冒用或盗用其账户及密码或任何其他未经合法授权之情形，或发生与账户关联的手机或其他设备遗失或其他可能危及到账户安全的情形时，应立即以有效方式通知本网站，向本网站申请中止相关服务。对用户的申请中止相关服务或采取其他行动需要合理期限，在此之前，对本网站已执行的指令及(或)所导致的任何损失用户自行承担责任。
	</div>
	<div>
		6.如用户使用他人信息和文件注册使用本网站服务或向本网站提供的信息和资料不符合注册的相关规定，由此引起的一切责任和后果均由实际进行注册的人全部承担，本网站不因此承担任何法律责任，如因此而给本网站及其他用户造成任何损失，用户应当承担赔偿本网站及其他用户损失的责任。
	</div>
	<div>
		7.用户不得利用本网站或本网站服务从事任何不符合中国法律法规、违反本协议或本网站其他规则、侵犯他人权益的活动。本网站在发现用户从事该等活动时，有权不经通知而立即中止或终止用户对本网站的全部或部分功能的使用。
	</div>
	<div>
		8.在使用本网站提供的服务（包括但不限于站内信服务、群组服务、论坛服务或其他电子邮件转发服务）的过程中，用户不得发送、公布或展示任何垃圾邮件或其他可能违反中国法律法规及本协议内容的信息。本网站在发现用户从事该等活动或发布该等内容时，有权不经用户同意而阻止该等活动并删除该等内容，同时有权不经通知而立即中止或终止用户对本网站的全部或部分功能的使用。
	</div>
	<div class="bold">
		9.<span class="border">用户同意</span>,在一些情况下本网站有权利中止或终止用户对本网站的全部或部分功能的使用，这些情况包括但不限于根据本协议的约定、法律法规及法律文书的规定、有权机关的要求；本网站基于单方面合理判断认为账户操作存在异常或风险；用户遭到第三方投诉，且第三方已经提供了相关证据。发生上述情况造成中止或终止用户对本网站的全部或部分功能的使用的，本网站将即时通知用户。如账户中止的用户需要恢复服务，应按本网站通知的具体要求提交相关信息、资料、说明等文件，以便本网站进行核实，且本网站有权自行决定是否同意用户的申请。
	</div>
	<div>
		10.中止用户使用本网站全部功能或部分功能即为账户中止，账户中止后本网站仍将保存账户内的所有相关资料，且可以查询和为用户提供相关文件内容的证明。
	</div>
	<div>
		11.终止用户使用本网站全部功能即为账户终止，账户终止将导致账户被注销的结果，由此产生的一切后果由用户自行承担（包括但不限于清除账户内的数据、无法查询、无法为用户提供相关文件内容的证明）。
	</div>
	<div>
		12.用户在注册时向本网站提交的电话、邮箱、用户名、密码及支付安全密码是用户在本网站的唯一识别信息。用户注册成功后，除非本协议另有约定，不得将注册的电话、邮箱、用户名、密码及支付安全密码转让或授权给第三方使用。<span class="bold"><span class="border">用户确认</span>，使用用户名和密码登陆本网站后在本网站的一切行为以及以用户在本网站注册时提交的个人电子邮箱发送邮件的行为均代表用户本人并由用户承担相应的法律后果。本网站按照用户操作发出的指令即时执行，除本网站提供撤销功能的服务外一律不可撤回或撤销。</span>
	</div>
	<div class="bold">
		13.<span class="border">用户认可</span>，账户内的数据以本网站记录为准，如用户对该等数据存有异议的，应自用户账户数据发生变动之日起72 小时内向本公司提出异议，并提供相关证据供本网站核实，否则视为用户认可该数据。
	</div>
	<div class="bold">
		14.<span class="border">用户知悉</span>：根据《电子签名法》的规定下列情形不适合使用电子文书：涉及婚姻、收养、继承等人身关系的；涉及土地、房屋等不动产权益转让的；涉及停止供水、供热、供气、供电等公用事业服务的；法律、行政法规规定的不适用电子文书的其他情形。因此，用户在本网站上签订的上述法律文件是不具有法律效力的。
	</div>
	<div class="h2">
		六、通知及送达
	</div>
	<div>
		1.本协议项下的通知如以公示方式作出，一经在本网站公示即视为已经送达。
	</div>
	<div>
		2.除此之外，其他向用户个人发布的具有专属性的通知将由本网站向用户在注册时或者注册后变更用户信息时向本网站提供的邮箱，或在本网站上用户个人账户中为用户设置的“用户消息”，或用户在注册后在本网站绑定的手机发送，一经发送即视为已经送达（本网站对用户是否收到或者及时收到该通知不承担责任）。
	</div>
	<div>
		3.用户承诺密切关注用户的邮箱、“用户消息”中的邮件和信息及手机中的短信信息，任何信息从本网站发出起，即视为已告知用户，用户不得以任何理由否认本协议变更后的效力或拒绝履行相关的义务。
	</div>
	<div class="h1">
		七、责任限制与免责条款
	</div>
	<div>
		1.联合信任仅承担本协议中明确约定的责任。
	</div>
	<div>
		2.以本网站提供的服务为基础而形成的交易所产生的任何风险应由用户与交易对方承担，本网站对此不提供任何形式的担保。
	</div>
	<div>
		3.账户的注册信息是由用户向本网站提交的，尽管本网站对开通和使用本网站服务的用户进行实名认证，但受限于目前实名认证手段的局限性和潜在漏洞，本网站无法保证该信息之准确、完整，因此用户应对自己的判断承担全部责任。
	</div>
	<div>
		4.如用户选择使用本网站的合作单位所提供的产品或服务，该产品或服务的品质及内容由该合作单位自行负责。
	</div>
	<div>
		5.由于GPS 定位误差导致定位错误或定位不能，联合信任免责。
	</div>
	<div>
		6.除本协议另有规定外，在任何情况下，本公司对本协议所承担的违约赔偿责任总额不超过向用户收取的当次服务费用总额。
	</div>
	<div>
		7.用户充分知晓，本网站有权同时为用户及用户交易的相对方提供服务，用户同意对本网站可能存在的该等行为予以明确豁免，并不得以此来主张本网站在提供本服务时存在法律上的瑕疵。
	</div>
	<div>
		8.为有效提供服务，本网站系统将不时进行维护和检测，因此产生的服务中断或不稳定状态，联合信任不承担损害赔偿责任。
	</div>
	<div>
		9.因国家相关主管部门颁布、变更的法令、政策导致本网站不能提供约定服务的，联合信任不承担任何责任，但将根据相关的法令、政策变更、取消、增加本网站的服务内容和本协议。
	</div>
	<div>
		10.因通信公司有线或无线通信系统、设备的检修、维护或不稳定，或黑客攻击，或电力部门技术调整或故障，或银行方面的问题等原因，导致本网站服务中断或不稳定，联合信任不承担损害赔偿责任，但本网站将在2小时内反应，并尽商业上的最大努力争取尽快恢复正常服务。
	</div>
	<div>
		11.因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成本网站无法提供服务的，联合信任不承担任何责任。
	</div>
	<div>
		12.因提供本网站服务所使用的网络、系统、其他软件本身的固有缺陷、运行错误而给用户造成的任何直接或间接损失（包括但不限于数据丢失、利润损失、丧失商业机会等），联合信任不承担赔偿责任。
	</div>
	<div>
		13.本网站对甲方因其帐号、密码、需要认证的文件等遗失、被盗、被误用或被擅自修改、计算机设备故障、操作失误等情况造成的损失不负责任，但由于联合信任原因造成的除外。
	</div>
	<div class="h1">
		八、法律适用及管辖
	</div>
	<div>
		1.本协议的订立、变更、执行和解释，以及与本协议有关的争议解决，均应适用中华人民共和国法律。如与本协议有关的某一特定事项没有法律规定或规定不明确，则应参照通用的国际商业惯例和行业惯例。
	</div>
	<div>
		2.如因本协议或本网站服务所引起或与其有关的任何争议应向联合信任所在地人民法院起诉。
	</div>
	<div class="h1">
		九、其他
	</div>
	<div>
		1.本网站内容可能涉及由第三方所有、控制或运营的其它网站（以下称“第三方网站”）。本网站不能保证也没有义务保证第三方网站上信息的真实性和有效性。用户应按照第三方网站的相关协议与规则使用第三方网站，而不是按照本协议。第三方网站的内容、产品、广告和其他任何信息均由用户自行判断并承担风险，而与本网站无关。
	</div>
	<div>
		2.用户在同意、接受本协议前应充分阅读、接受并同意《隐私保护协议》的全部规定。本协议自用户同意勾选并成功注册为本网站用户之日起生效，除非本网站终止本协议或者用户注销账户，否则本协议始终有效。本协议终止并不免除用户根据本协议或其他有关协议、规则已经产生的义务和责任。
	</div>
	<div>
		3.用户利用本网站或本网站服务从事任何不符合中国法律法规、违反本协议或本网站其他规则、侵犯他人权益的活动，使第三方向联合信任及其代理人提出赔偿请求（包括司法费用和其他专业人士的费用），如联合信任及其代理人承担了赔偿责任即获得了向该用户追偿的权利，该用户应承担全部赔偿费用以使联合信任及其代理人免遭损失。
	</div>
	<div>
		4.本协议中的任何条款完全或部分无效或不具有执行力，不影响本协议的其余条款的效力。
	</div>
	<div>
		5.本协议的标题仅为方便而设，在解释本协议时应被忽略。
	</div>
	<div>
		6.联合信任对本协议享有最终的解释权。
	</div>


</div>
  </div>
</template>

<script>
  import cheader from '@/components/header';
  export default {
    data () {
      return {
      }
    },
    methods: {
      goback: function () {
        history.go(-1); //后退1页
      }
    }
  }
</script>
<style scoped>
.wrap{width:100%; max-width: 1200px; margin: 0 auto; padding: 25px 20px; line-height: 30px; box-sizing: border-box;}
		.bold{font-weight: bold;}
		.title{font-size:24px; color:#000; text-align: center; margin-bottom: 30px;}
		.h1{font-weight: bold; color:#000; font-size: 18px;}
		.h2{font-weight: bold; color:#000; font-size: 16px;}
		.red{color:red;}
		.h3{padding-left:2em}
		.border{border:1px solid #000}
		@media screen and (min-width:320px) and (max-width:420px) {
		    .wrap {
		        line-height: 30px;
		    }
		    .title{
		    	margin-bottom: 20px;
		    }
		}
</style>



// WEBPACK FOOTER //
// src/module/register/RegProtocol.vue